import { Catalog } from '@df/catalog/catalog.interfaces';
import { NICmsContentField } from '@icms/core/content';

export namespace NMaterialsCalculatorCms {
    export const BLOCK_ID = 'cms-materials-calculator';

    export type IBlockData = Catalog.IBlockData<IBlockDataContent>;

    export interface IBlockDataContent {
        // brick block
        brickTitle: string;
        brickDescription: string;
        brickImage: string;
        blockImage: string;
        // concrete
        concreteTitle: string;
        concreteDescription: string;
        // decking
        deckingTitle: string;
        deckingDescription: string;
        // patio
        patioTitle: string;
        patioDescription: string;
        // paving
        pavingTitle: string;
        pavingDescription: string;
        pavingBrandImage: string;
        patternImage1: string;
        patternImage2: string;
        patternImage3: string;
        patternImage4: string;
        patternImage5: string;
        patternImage6: string;
        patternImage7: string;
        patternImage8: string;
        patternImage9: string;
        patternImage10: string;
        patternImage11: string;
        patternImage12: string;
        patternImage13: string;
        pavingDoc: string;
    }

    export const fields = [
        {
            type: NICmsContentField.EFieldType.text,
            key: 'concreteTitle',
            title: 'Concrete title',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'concreteDescription',
            title: 'Concrete description',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'deckingTitle',
            title: 'Decking title',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'deckingDescription',
            title: 'Decking description',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'patioTitle',
            title: 'Patio Mortar title',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'patioDescription',
            title: 'Patio Mortar description',
            required: true
        },

        {
            type: NICmsContentField.EFieldType.text,
            key: 'brickTitle',
            title: 'Brick block title',
            group: 'Brick/Block',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'brickDescription',
            title: 'Brick block description',
            group: 'Brick/Block',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'brickImage',
            title: 'Brick image',
            group: 'Brick/Block',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'blockImage',
            title: 'Block image',
            group: 'Brick/Block',
            required: true
        },

        {
            type: NICmsContentField.EFieldType.text,
            key: 'pavingTitle',
            title: 'Paving title',
            group: 'Paving',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'pavingDescription',
            title: 'Paving description',
            group: 'Paving',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.document,
            key: 'pavingDoc',
            title: 'Paving document',
            group: 'Paving',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'pavingBrandImage',
            title: 'Paving brand image',
            group: 'Paving',
            required: true
        },

        {
            type: NICmsContentField.EFieldType.image,
            key: 'patternImage1',
            title: 'Pattern image 1',
            group: 'Paving',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'patternImage2',
            title: 'Pattern image 2',
            group: 'Paving',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'patternImage3',
            title: 'Pattern image 3',
            group: 'Paving',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'patternImage4',
            title: 'Pattern image 4',
            group: 'Paving',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'patternImage5',
            title: 'Pattern image 5',
            group: 'Paving',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'patternImage6',
            title: 'Pattern image 6',
            group: 'Paving',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'patternImage7',
            title: 'Pattern image 7',
            group: 'Paving',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'patternImage8',
            title: 'Pattern image 8',
            group: 'Paving',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'patternImage9',
            title: 'Pattern image 9',
            group: 'Paving',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'patternImage10',
            title: 'Pattern image 10',
            group: 'Paving',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'patternImage11',
            title: 'Pattern image 11',
            group: 'Paving',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'patternImage12',
            title: 'Pattern image 12',
            group: 'Paving',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'patternImage13',
            title: 'Pattern image 13',
            group: 'Paving',
            required: true
        }
    ];
}
